import { useSelectableItemsContext } from '..';
import { Checkbox } from '@/shadcn/checkbox';

export const SelectableItemWrapper = ({
  children
}: React.PropsWithChildren) => {
  const { selected, handleChangeCheck } = useSelectableItemsContext();

  return (
    <div className="flex items-center gap-4">
      <Checkbox onCheckedChange={handleChangeCheck} checked={selected} />
      <div className="flex-1">{children}</div>
    </div>
  );
};
